import React from "react";
import { Link, useMatch } from "react-router-dom";

import Search from "./Search";

function Layout({ children }) {
  const match = useMatch("/alltransactions");
  return (
    <div className={`flex flex-col main w-full h-full  `}>
      <nav className="fixed flex items-center justify-between px-6 w-full h-16 border-b-[1px] border-slate-800 bg-black/30">
        <div className="">
          <p className="text-3xl text-slate-300">Expense Tracker</p>
        </div>
        <div className=" flex justify-between items-center gap-20 ">
          {match && (
            <Link
              className="text-slate-300 hover:text-sky-500 hover:tracking-[2px]	ease-in duration-300"
              to="/"
            >
              Home
            </Link>
          )}
          <Search />
        </div>
      </nav>
      <div className="w-full h-full flex flex-col items-center justify-center pt-20">
        {children}
      </div>
    </div>
  );
}

export default Layout;
